import "./Factory.scss";
import React from "react";
import { useDispatch } from "react-redux";
import ColorEditor from "../ColorEditor";
import ColorSelector from "../ColorSelector/ColorSelector";
import Label from "../Label";
import ListItem from "../ListItem";
import NavBar from "../NavBar";
import RichText from "../RichText";
import Slider from "../Slider";
import Tabs from "../Tabs";
import Switch from "../Switch";
import ButtonGroup from "../ButtonGroup";
import Image from "../Image";

const Factory = (props) => {
  switch (props.type) {
    case "NavBar":
      return <NavBar {...props} />;

    case "Tabs":
      return <Tabs {...props} />;

    case "Label":
      return <Label {...props} />;

    case "RichText":
      return <RichText {...props} />;

    case "Slider":
      return <Slider {...props} />;

    case "Switch":
      return <Switch {...props} />;

    case "ButtonGroup":
      return <ButtonGroup {...props} />;

    case "ListItem":
      return <ListItem {...props} />;

    case "BooleanEditor":
      return <BooleanEditor {...props} />;

    case "NumberEditor":
      return <NumberEditor {...props} />;

    case "StringEditor":
      return <StringEditor {...props} />;

    case "SelectEditor":
      return <SelectEditor {...props} />;

    case "ColorEditor":
      return <ColorEditor {...props} />;

    case "Category":
      return <Category {...props} />;

    case "ColorSelector":
      return <ColorSelector {...props} />;

    case "Image":
      return <Image {...props} />;

    default:
      return <DefaultEditor {...props} />;
  }
};

export default Factory;

const DefaultEditor = React.memo((props) => {
  const dispatch = useDispatch();
  return (
    <div onClick={(e) => dispatch(props.action)}>
      DefaultEditor: {props.value?.toString()}
    </div>
  );
});

const BooleanEditor = React.memo((props) => {
  const dispatch = useDispatch();
  return (
    <div className="BooleanEditor">
      <label>
        <input
          type="checkbox"
          checked={props.value}
          onChange={(e) => dispatch(props.action)}
        />
        {props.label}
      </label>
    </div>
  );
});

const StringEditor = React.memo((props) => {
  const dispatch = useDispatch();
  return (
    <div className="StringEditor">
      <label>
        <input
          value={props.value}
          onChange={(e) => {
            const value = e.target.value;
            dispatch({
              ...props.action,
              payload: {
                ...props.action.payload,
                value,
              },
            });
          }}
        />
        {props.label}
      </label>
    </div>
  );
});

const NumberEditor = React.memo((props) => {
  const dispatch = useDispatch();
  return (
    <div className="NumberEditor">
      <label>
        <input
          value={props.value}
          onChange={(e) => {
            if (!isNaN(e.target.value) && e.target.value.charAt(-1) !== ".") {
              const value = Number(e.target.value);
              dispatch({
                ...props.action,
                payload: {
                  ...props.action.payload,
                  value,
                },
              });
            }
          }}
        />
        {props.label}
      </label>
    </div>
  );
});

const SelectEditor = React.memo((props) => {
  const dispatch = useDispatch();
  return (
    <div className="SelectEditor">
      <label>
        <select
          value={props.value}
          onChange={(e) => {
            const value = e.target.value;
            dispatch({
              ...props.action,
              payload: {
                ...props.action.payload,
                value,
              },
            });
          }}
        >
          {props.options.map((item, index) => {
            const value = typeof item === "object" ? item.value : item;
            const label = typeof item === "object" ? item.label : item;
            return (
              <option key={index} value={value}>
                {label}
              </option>
            );
          })}
        </select>
        {props.label}
      </label>
    </div>
  );
});

// https://casesandberg.github.io/react-color/
/* const ColorEditor = React.memo((props) => {
  const [color, setColor] = useState({ r: 51, g: 51, b: 51, a: 0.5 });
  const dispatch = useDispatch();
  return (
    <div className="ColorEditor">
      <ChromePicker
        color={color}
        onChange={setColor}
        onChangeComplete={(e) => {
          const value = (e.rgb.r << 16) + (e.rgb.g << 8) + e.rgb.b;
          dispatch({
            ...props.action,
            payload: {
              ...props.action.payload,
              value,
            },
          });
        }}
      />
    </div>
  );
}); */

const Category = React.memo((props) => {
  return <div className="Category">{props.label}</div>;
});
